import React from "react";
import { useSelector } from "react-redux";
import { Navigate, Outlet, useLocation } from "react-router";

function ProtectedRoutes() {
  const user = useSelector((state) => state.user);
  const currentUrl = useLocation();

  if (!user.token) {
    return <Navigate to={`/login?previousUrl=${currentUrl.pathname}`} />;
  }

  return <Outlet />;
}

export default ProtectedRoutes;
